<h1 mat-dialog-content>{{ header | translate }}</h1>

@if (translate) {
  <div>
    @for (text of textArray; track text) {
      <p>{{ text | translate }}</p>
    }
  </div>
} @else {
  @for (text of textArray; track text) {
    <p>{{ text }}</p>
  }
}
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button color="primary" mat-dialog-close tabindex="-1" (click)="onConfirm()">{{ 'Close' | translate }}</button>
</div>
